import { forwardRef } from 'react';

import MuIButton from '@mui/material/Button';

const Button = forwardRef((props, ref) => {
  return <MuIButton ref={ref} {...props} />;
});
Button.displayName = 'Button';
export default Button;
